module.exports = __webpack_public_path__ + "static/media/rhino_fda_pilot.f342f26c.png";